const styleOverrides = {
  root: {
    padding: '0px',
  },
};

export default styleOverrides;
